export default async function getApps({ context, nextMiddleware }) {
  console.log('getApps');
  try {
    await context.store.bankStore.getTakers();
    await context.store.bankStore.getOffices();
    await context.store.bankStore.getStatusCount();
    await context.store.bankStore.getSigners();
    await context.store.bankStore.getSysParameters();
  } catch (e) {
    console.error(e);
    return context.next(false);
  }
  return nextMiddleware();
}
